<template>
  <div id="pre-high-content" class="pre-highLight-h5">
    <div class="content-title">高级版功能亮点</div>
    <div class="content-item" v-for="(item, index) in dataList" :key="index">
      <p class="item-title">{{ item.title }}</p>
      <img :src="item.img" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: Array,
  },
}
</script>

<style lang="less" scoped>
@base-scale: calc((100vw / 375));
.pre-highLight-h5 {
  background-color: #fff;
  overflow: hidden;
  .content-title {
    -webkit-text-size-adjust: none;
    width: calc(@base-scale*234);
    height: calc(@base-scale*22);
    font-size: calc(@base-scale*16);
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: center;
    margin: calc(@base-scale*40) auto calc(@base-scale*23);
  }
  .content-item {
    width: calc(@base-scale*345);
    height: calc(@base-scale*44);
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: calc(@base-scale*16);
    .item-title {
      height: calc(@base-scale*21);
      font-size: calc(@base-scale*15);
      line-height: calc(@base-scale*21);
      font-weight: 500;
      position: absolute;
      left: calc(@base-scale*12);
    }
  }
  .content-item:last-child {
    margin-bottom: 0;
  }
}
</style>
